import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import SimpleHeader from '../../../../ui-kit/SimpleHeader';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import Button from '../../../../ui-kit/Button';
import { isAuthAtom } from '../../../../atoms/accountAtoms';
import MyVideo from '../../../../components/MyVideo';
import { resourcePathAtom, siteModulesAtom } from '../../../../atoms/globalAtoms';
import Slider1Image from '../../../../assets/images/mainSlider/1.PNG';
import Slider2Image from '../../../../assets/images/mainSlider/2.PNG';
import Slider3Image from '../../../../assets/images/mainSlider/3.PNG';
import Slider4Image from '../../../../assets/images/mainSlider/4.PNG';
import Slider5Image from '../../../../assets/images/mainSlider/5.PNG';

function ConfigInstructions() {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [isAuth] = useAtom(isAuthAtom);
  const [siteModules] = useAtom(siteModulesAtom);
  const [resourcePath] = useAtom(resourcePathAtom);

  const aboutModule = useMemo(() => siteModules?.find((i) => i.module_name === 'about'), [siteModules]);
  const videoUrl = useMemo(() => {
    if (!aboutModule?.meta?.video || !resourcePath) return '';

    return resourcePath + aboutModule.meta.video[0];
  }, [aboutModule, resourcePath]);

  const onCreateClick = () => {
    navigate(isAuth ? '/configurator' : '/login');
  };

  return (
    <section className={styles.instruction}>
      <div className={classNames('container')}>
        <div className={styles.instructionInner}>
          <SimpleHeader
            title={t(DICTIONARY.configInstructionsTitle)}
            subtitle={t(DICTIONARY.configInstructionsSubTitle)}
            isCenter
          />

          <div className={styles.frameWrapper}>
            <div className={styles.blueFrame}>
              <div className={styles.frameInner}>
                <MyVideo url={videoUrl} />
                {/* <MyVideo url="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4" /> */}
              </div>
            </div>
          </div>

          <div className={styles.descriptionWrapper}>
            <p>
              {t(DICTIONARY.configInstructionsDescription)}
            </p>
          </div>

          <div className={styles.buttonWrapper}>
            <Button
              text={t(DICTIONARY.createConfigurationButton)}
              width="100%"
              onClick={onCreateClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ConfigInstructions;
